import React from "react";
import ReactFancyBox from "react-fancybox";

const GalleryPicture = ({
  module,
  picture,
  loading,
  confirmAndRemovePicture,
  confirmAndArchivePicture,
  confirmAndRestorePicture,
  updatePictureHandler,
}) => {
  return (
    <div className="card borderOrange bg-custom-5">
      <div className="card-body d-flex align-items-center justify-content-center pb-0">
        <div
          className="galleryImage photoInsideAlbum"
          style={{
            width: "100%",
            height: "200px", // 👈 same fixed height for all
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          {picture?.type === "image" ? (
            <ReactFancyBox
              thumbnail={
                picture.source === "Instagram"
                  ? picture.image
                  : process.env.REACT_APP_BACKEND_URL + "public/" + picture.image
              }
              image={
                picture.source === "Instagram"
                  ? picture.image
                  : process.env.REACT_APP_BACKEND_URL + "public/" + picture.image
              }
              caption={picture.title}
            />
          ) : picture?.type === "video" && picture?.video ? (
            <iframe
              src={picture.video}
              title={picture.title || "Video"}
              frameBorder="0"
              width="100%"
              height="100%"
              style={{
                objectFit: "contain", 
              }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          ) : (
            <div>No media available</div>
          )}
        </div>

        {(picture.status === "0" || picture.status === 0) && (
          <div className="ribbon-wrapper">
            <div className="ribbon bg-danger">Archived</div>
          </div>
        )}
      </div>

      {(!picture.source || picture.source !== "Instagram") && (
        <div className="card-footer text-center">
          <span
            title="Edit Item"
            onClick={() => updatePictureHandler(picture)}
            className="btn btn-outline-custom-1 mx-1"
          >
            <i className="fas fa-pencil-alt"></i>
          </span>

          <span
            title="Delete Item"
            onClick={() => confirmAndRemovePicture(picture._id)}
            className="btn btn-outline-custom-1 mx-1"
          >
            <i className="fas fa-trash"></i>
          </span>

          {(picture.status === "1" || picture.status === 1) && (
            <span
              title="Block Item"
              onClick={() => confirmAndArchivePicture(picture._id)}
              className="btn btn-outline-custom-1 mx-1"
            >
              <i className="fas fa-ban"></i>
            </span>
          )}

          {(picture.status === "0" || picture.status === 0) && (
            <span
              title="Remove Ban"
              onClick={() => confirmAndRestorePicture(picture._id)}
              className="btn btn-outline-custom-1 mx-2"
            >
              <i className="fas fa-undo"></i>
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default GalleryPicture;
